import { ADMIN_CONTEXT } from "./api-context";
import { AUTH_CONTEXT } from "./api-context";

export const ONBOARDING = {
    SEGMENTS: `${ADMIN_CONTEXT}business-units/segments`,
    ACCESS_REQUEST: `${AUTH_CONTEXT}request_access_sop/`,
    USER_PROFILE: `${AUTH_CONTEXT}user_profile_list_v2/`
}